export default "/images/si-img2.jpg?f153f12dacfe151b225204e087943eb5";